import { createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/Bookit-logo.svg'
import _imports_1 from '@/assets/icons/Bookit-dark-logo.svg'
import _imports_2 from '@/assets/lang/HE.png'
import _imports_3 from '@/assets/lang/EN.png'
import _imports_4 from '@/assets/lang/RU.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-6d407bb2")

_pushScopeId("data-v-6d407bb2")
const _hoisted_1 = { class: "wrapper fadeInDown p-0 pt-lg-4" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("img", {
    class: "logo",
    src: _imports_0
  })
], -1)
const _hoisted_3 = { class: "page-header-title" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = {
  type: "submit",
  class: "bookit-button w-100"
}
const _hoisted_7 = {
  key: 0,
  class: "nav-links-block"
}
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = {
  type: "submit",
  class: "bookit-button w-100"
}
const _hoisted_10 = { class: "d-flex pt-2 login-language-select" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('navbar.menuBO')), 1),
    (!_ctx.forgotPassword)
      ? (_openBlock(), _createBlock("form", {
          key: 0,
          class: "loginForm",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
        }, [
          _createVNode("div", _hoisted_4, [
            _createVNode("label", null, _toDisplayString(_ctx.$t('login.username')), 1),
            _withDirectives(_createVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.Username = $event)),
              class: "form-control form-control-lg",
              placeholder: _ctx.$t('login.username')
            }, null, 8, ["placeholder"]), [
              [_vModelText, _ctx.Username]
            ])
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("label", null, _toDisplayString(_ctx.$t('login.password')), 1),
            _withDirectives(_createVNode("input", {
              type: "password",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.Password = $event)),
              class: "form-control form-control-lg",
              placeholder: "********"
            }, null, 512), [
              [_vModelText, _ctx.Password]
            ])
          ]),
          _createVNode("button", _hoisted_6, _toDisplayString(_ctx.$t('login.signIn')), 1),
          false
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _createVNode("span", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.forgotPassword = true)),
                  class: "pointer"
                }, _toDisplayString(_ctx.$t('login.iForgotMyPassword')), 1)
              ]))
            : _createCommentVNode("", true)
        ], 32))
      : (_openBlock(), _createBlock("form", {
          key: 1,
          class: "loginForm mt-5",
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetPassword && _ctx.resetPassword(...args)), ["prevent"]))
        }, [
          _createVNode("div", _hoisted_8, [
            _createVNode("label", null, _toDisplayString(_ctx.$t('login.usernameEmail')), 1),
            _withDirectives(_createVNode("input", {
              type: "password",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.usernameOrEmail = $event)),
              class: "form-control form-control-lg",
              placeholder: "Type username or email"
            }, null, 512), [
              [_vModelText, _ctx.usernameOrEmail]
            ])
          ]),
          _createVNode("button", _hoisted_9, _toDisplayString(_ctx.$t('login.resetPassword')), 1)
        ], 32)),
    _createVNode("img", {
      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.forgotPassword = false)),
      src: _imports_1,
      class: "login-registration-logo"
    }),
    _createVNode("div", _hoisted_10, [
      _createVNode("div", {
        class: ["my-auto", { active: _ctx.locale == 'he-IL' }]
      }, [
        _createVNode("img", {
          class: "language-image",
          src: _imports_2,
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeLang('he-IL')))
        })
      ], 2),
      _createVNode("div", {
        class: ["m-2 my-auto", { active: _ctx.locale == 'en-US' }]
      }, [
        _createVNode("img", {
          class: "language-image",
          src: _imports_3,
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeLang('en-US')))
        })
      ], 2),
      _createVNode("div", {
        class: ["my-auto", { active: _ctx.locale == 'ru-RU' }]
      }, [
        _createVNode("img", {
          class: "language-image",
          src: _imports_4,
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changeLang('ru-RU')))
        })
      ], 2)
    ])
  ]))
})